import type React from 'react';

import { PopoverContext } from './Provider';
import type { PopoverProps } from './types';
import { usePopover } from './usePopover';

const Popover = ({
  children,
  modal = false,
  ...restOptions
}: {
  children: React.ReactNode;
} & PopoverProps) => {
  // This can accept any props as options, e.g. `placement`,
  // or other positioning options.
  const popover = usePopover({ modal, ...restOptions });
  return (
    <PopoverContext.Provider value={popover}>
      {children}
    </PopoverContext.Provider>
  );
};

export default Popover;

export type { PopoverProps };

export { PopoverContent, type PopoverContentProps } from './PopoverContent';
export { PopoverList } from './PopoverList';
export { PopoverListItem } from './PopoverListItem';
export { PopoverTrigger } from './PopoverTrigger';
